export const SET_DATA_COMPANY = "[COMPANY_TYPES] SET_DATA_PROFILE";
export const SET_DATA_TENANT = "[COMPANY_TYPES] SET_DATA_TENANT";
export const CREATE_DATA_COMPANY = "[COMPANY_TYP] CREATE_DATA_COMPANY";
export const UPDATE_DATA_COMPANY = "[COMPANY_TYPES] UPDATE_DATA_COMPANY";
export const ACTIVATE_COMPANY = "[COMPANY_TYPES] ACTIVATE_COMPANY";
export const DEACTIVATE_COMPANY = "[COMPANY_TYPES] DEACTIVATE_COMPANY";
export const SET_DATA_DETAIL_TENANT = "[COMPANY_TYPES] SET_DATA_DETAIL_TENANT";
export const UPDATE_CONFIG_APP_TENANT = "[COMPANY_TYPES] UPDATE_CONFIG_APP_TENANT";
